import ClickOutSideDiv from './ClickOutSideDiv';
import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import ProductCard from './ProductCard';
import { useTranslation } from 'react-i18next';
import { currencyOptions } from '../../staticData/options';
import { useHistory } from 'react-router-dom';
import localRequest from '../../services/LocalServer/localRequest';
import FAQ from './FAQ';
import Swal from 'sweetalert2';

function BottomCard(props) {
  const cash_pay = localStorage.getItem('CASH_PAY') === 'TRUE';
  const history = useHistory();
  const { cart, setShowCart, showCart, langs, remove, isLocal, decreStock } = props;
  const { t } = useTranslation();
  const machineData = JSON.parse(localStorage.getItem('machine'));
  const hasTerm =
    machineData?.themeColor?.termCondition?.length > 0 &&
    machineData?.themeColor?.termCondition[0].content?.en?.length > 0;
  const machineID = machineData._id;
  const tax = machineData.tax;
  const tax_rate = machineData.tax_rate;
  let symbol = JSON.parse(localStorage.getItem('machine'))?.currency?.symbol;
  const testMode = localStorage.getItem('testMode');
  symbol = symbol ? symbol : '$';

  const [mainL, setMainL] = useState('en-US');
  const [showTerm, setShowTerm] = useState(false);
  const [products, setProducts] = useState(<div></div>);
  const [check, setcheck] = useState(true);

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    }
  }, []);

  useEffect(() => {
    console.log(cart);
    if (cart.length === 0) {
      setShowCart(false);
    }
  }, [cart]);

  let totalPrice = 0;
  let finalTax = 0;

  const calculateitemPrice = (item) => {
    return (
      <span>
        {mainL != 'fr-CA' && symbol}
        {parseFloat((item.price * item.quantity).toFixed(2)).toLocaleString(mainL, currencyOptions)}
        {mainL == 'fr-CA' && symbol}
      </span>
    );
  };

  const term = () => {
    setShowTerm(true);
  };

  const handleCheck = () => {
    setcheck(!check);
  };

  const calculateDiscount = (cart) => {
    const discount = cart.reduce((totalCost, item) => {
      if (item?.buyX > 1) {
        if (item.quantity === 1) {
          return totalCost;
        }
        if (item.quantity > 1) {
          if (item.quantity % item.buyX === 0) {
            if (item.percentage) {
              return (
                totalCost +
                parseFloat(
                  (item.price * item.quantity - item.discountedPrice * item.quantity).toFixed(2)
                )
              );
            } else {
              return (
                totalCost +
                parseFloat((item.discount * Math.trunc(item.quantity / item.buyX)).toFixed(2))
              );
            }
          } else {
            if (item.quantity < item.buyX) return totalCost;
            else {
              if (item.percentage == true) {
                return (
                  totalCost +
                  parseFloat(
                    (item.price * item.quantity - item.discountedPrice * item.quantity).toFixed(2)
                  )
                );
              } else {
                return (
                  totalCost +
                  parseFloat((item.discount * Math.trunc(item.quantity / item.buyX)).toFixed(2))
                );
              }
            }
          }
        } else return totalCost;
      } else if (item.buyX === 1) {
        if (item.discount != 0)
          return totalCost + parseFloat((item.price - item.discountedPrice).toFixed(2));
        else return totalCost;
      } else {
        if (item.discount > 0) {
          return (
            totalCost + parseFloat(((item.price - item.discountedPrice) * item.quantity).toFixed(2))
          );
        } else {
          return totalCost;
        }
      }
    }, 0);
    return discount;
  };

  const FinalProducts = cart.reduce((acc, item) => {
    item.price = parseFloat(item.price.toFixed(2));
    // item.discountedPrice = parseFloat(item.discountedPrice.toFixed(2));
    if (item?.buyX === 1) {
      if (item.quantity > 1) {
        return acc.concat([
          {
            item_id: Math.floor(10000000 + Math.random() * 90000000),
            picture: item.image,
            prodType: item.prodType,
            referTo: item.referTo,
            product: item.id,
            upc: item.upc,
            title: item.title,
            promo: null,
            quantity: item.quantity - 1,
            discount: 0,
            soldPrice: parseFloat((item.price * (item.quantity - 1)).toFixed(2)),
            emailCode: item.emailCode,
            addition: item.addition,
            tax: item.tax,
          },
          {
            item_id: Math.floor(10000000 + Math.random() * 90000000),
            picture: item.image,
            prodType: item.prodType,
            product: item.id,
            referTo: item.referTo,
            upc: item.upc,
            title: item.title,
            promo: item.promo,
            quantity: 1,
            discount: item.percentage
              ? parseFloat((item.discount * item.price).toFixed(2))
              : item.discount,
            soldPrice: parseFloat(item.discountedPrice.toFixed(2)),
            emailCode: item.emailCode,
            addition: item.addition,
            tax: item.tax,
          },
        ]);
      } else if (item.quantity == 1) {
        return acc.concat([
          {
            item_id: Math.floor(10000000 + Math.random() * 90000000),
            picture: item.image,
            prodType: item.prodType,
            referTo: item.referTo,
            product: item.id,
            upc: item.upc,
            title: item.title,
            promo: item.promo,
            quantity: 1,
            discount: item.percentage
              ? parseFloat((item.discount * item.price).toFixed(2))
              : item.discount,
            soldPrice: parseFloat(item.discountedPrice.toFixed(2)),
            emailCode: item.emailCode,
            addition: item.addition,
            tax: item.tax,
          },
        ]);
      }
    } else if (item.buyX > 1) {
      if (item.quantity < item.buyX) {
        return acc.concat([
          {
            item_id: Math.floor(10000000 + Math.random() * 90000000),
            picture: item.image,
            prodType: item.prodType,
            referTo: item.referTo,
            product: item.id,
            upc: item.upc,
            title: item.title,
            promo: null,
            quantity: item.quantity,
            discount: 0,
            soldPrice: item.price * item.quantity,
            emailCode: item.emailCode,
            addition: item.addition,
            tax: item.tax,
          },
        ]);
      }
      if (item.quantity >= item.buyX) {
        if (item.pQuantity * item.buyX === item.quantity) {
          if (item.percentage) {
            return acc.concat([
              {
                item_id: Math.floor(10000000 + Math.random() * 90000000),
                picture: item.image,
                prodType: item.prodType,
                referTo: item.referTo,
                product: item.id,
                upc: item.upc,
                title: item.title,
                promo: item.promo,
                quantity: item.quantity,
                discount: parseFloat((item.discount * item.price * item.quantity).toFixed(2)),
                soldPrice: parseFloat((item.discountedPrice * item.quantity).toFixed(2)),
                emailCode: item.emailCode,
                addition: item.addition,
                tax: item.tax,
              },
            ]);
          } else {
            return acc.concat([
              {
                item_id: Math.floor(10000000 + Math.random() * 90000000),
                picture: item.image,
                prodType: item.prodType,
                referTo: item.referTo,
                product: item.id,
                upc: item.upc,
                title: item.title,
                promo: item.promo,
                quantity: item.quantity,
                // discount: parseFloat((item.discount/item.buyX).toFixed(2)),
                discount: item.discount * item.pQuantity,
                soldPrice: parseFloat(
                  (item.price * item.quantity - item.discount * item.pQuantity).toFixed(2)
                ),
                emailCode: item.emailCode,
                addition: item.addition,
                tax: item.tax,
              },
            ]);
          }
        } else {
          if (item.percentage) {
            return acc.concat([
              {
                item_id: Math.floor(10000000 + Math.random() * 90000000),
                picture: item.image,
                prodType: item.prodType,
                referTo: item.referTo,
                product: item.id,
                upc: item.upc,
                title: item.title,
                promo: item.promo,
                quantity: item.quantity,
                discount: parseFloat((item.discount * item.price * item.quantity).toFixed(2)),
                soldPrice: parseFloat((item.discountedPrice * item.quantity).toFixed(2)),
                emailCode: item.emailCode,
                addition: item.addition,
                tax: item.tax,
              },
            ]);
          } else {
            return acc.concat([
              {
                item_id: Math.floor(10000000 + Math.random() * 90000000),
                picture: item.image,
                prodType: item.prodType,
                referTo: item.referTo,
                product: item.id,
                upc: item.upc,
                title: item.title,
                promo: null,
                quantity: item.quantity - item.pQuantity * item.buyX,
                discount: 0,
                soldPrice: item.price * (item.quantity - item.pQuantity * item.buyX),
                emailCode: item.emailCode,
                addition: item.addition,
                tax: item.tax,
              },
              {
                item_id: Math.floor(10000000 + Math.random() * 90000000),
                picture: item.image,
                prodType: item.prodType,
                referTo: item.referTo,
                product: item.id,
                upc: item.upc,
                title: item.title,
                promo: item.promo,
                quantity: item.pQuantity * item.buyX,
                discount: item.discount * item.pQuantity,
                soldPrice: parseFloat(
                  (item.price * item.quantity - item.discount * item.pQuantity).toFixed(2)
                ),
                emailCode: item.emailCode,
                addition: item.addition,
                tax: item.tax,
              },
            ]);
          }
        }
      }
    } else {
      return acc.concat([
        {
          item_id: Math.floor(10000000 + Math.random() * 90000000),
          picture: item.image,
          prodType: item.prodType,
          referTo: item.referTo,
          product: item.id,
          upc: item.upc,
          title: item.title,
          promo: item.promo,
          quantity: item.quantity,
          discount: item.percentage
            ? parseFloat((item.discount * item.price * item.quantity).toFixed(2))
            : item.discount * item.quantity,
          soldPrice: parseFloat((item.discountedPrice * item.quantity).toFixed(2)),
          emailCode: item.emailCode,
          addition: item.addition,
          tax: item.tax,
        },
      ]);
    }
  }, []);

  const checkout = async () => {
    if (cart && cart.length > 0) {
      if (!check && hasTerm) {
        return Swal.fire({
          text: t(`Please read and check the terms and conditions box before checkout`),
          icon: 'info',
        }).then(() => {});
      }

      localStorage.setItem('FinalProducts', JSON.stringify(FinalProducts));
      localStorage.setItem('TotalPrice', JSON.stringify(totalPrice));
      localStorage.setItem('FinalTax', JSON.stringify(finalTax));
      const items = FinalProducts.reduce((acc, product) => {
        const tax_amount = product.tax;
        const array = [];
        for (let i = 0; i < product.quantity; i++) {
          const FprodName =
            product.title[langs] && product.title[langs] !== ''
              ? product.title[langs]
              : product.title?.en;
          array.push({
            item_id: Math.floor(10000000 + Math.random() * 90000000),
            product_name: FprodName,
            upc: product.upc,
            quantity: 1,
            soldPrice: product.soldPrice / product.quantity,
            tax_amount: tax_amount,
            prodType: product.prodType,
            referTo: product.referTo,
            product: product.product,
            emailCode: product.emailCode,
            discount: product.discount / product.quantity,
            promo: product.promo,
            picture: product.picture,
            total_amount: parseFloat(
              (product.soldPrice / product.quantity + tax_amount).toFixed(2)
            ),
          });
        }
        return acc.concat(array);
      }, []);
      localStorage.setItem('SeparateItem', JSON.stringify(items));
      let order_info = {
        order_id: Math.floor(10000000 + Math.random() * 90000000),
        item_amount: FinalProducts.length,
        tax_amount: finalTax,
        total_amount: totalPrice,
        items: items,
      };
      localStorage.setItem('order_info', JSON.stringify(order_info));
      // console.log(items);
      if (testMode === 'false') {
        if (cash_pay) {
          history.push(`/machineUI/selectPayment/${machineID}`);
        } else {
          await localRequest({
            method: 'post',
            url: '/updateKioskStatus',
            data: {
              status: 'OrderCreated',
              order_info: order_info,
            },
          }).then((res) => {
            history.push(`/machineUI/payment/${machineID}`);
          });
        }
        // history.push(`/machineUI/product-dispense/${machineID}`);
      } else {
        history.push(`/machineUI/product-dispense/${machineID}`);
      }
    }
  };

  const calculateSub = (cart) => {
    const total = cart.reduce((totalCost, item) => {
      let result = 0;
      if (item?.buyX > 1) {
        if (item.quantity === 1) {
          result = item.price;
        }
        if (item.quantity > 1) {
          if (item.quantity % item.buyX === 0) {
            if (item.percentage) {
              result =
                parseFloat((item.price * item.quantity).toFixed(2)) -
                parseFloat((item.price * item.quantity * item.discount).toFixed(2));
            } else {
              result =
                parseFloat((item.price * item.quantity).toFixed(2)) -
                parseFloat((item.discount * item.pQuantity).toFixed(2));
            }
          } else {
            if (item.quantity < item.buyX) {
              result = parseFloat((item.price * item.quantity).toFixed(2));
            } else {
              if (item.percentage == true) {
                result =
                  parseFloat((item.price * item.quantity).toFixed(2)) -
                  parseFloat((item.price * item.quantity * item.discount).toFixed(2));
              } else {
                result = parseFloat(
                  (
                    item.price * item.buyX * item.pQuantity -
                    item.discount +
                    item.price * (item.quantity - item.buyX * item.pQuantity)
                  ).toFixed(2)
                );
              }
            }
          }
        }
      } else if (item.buyX === 1) {
        result = parseFloat((item.discountedPrice + item.price * (item.quantity - 1)).toFixed(2));
      } else {
        result = parseFloat((item.discountedPrice * item.quantity).toFixed(2));
      }

      // apply tax
      if (!tax && typeof tax_rate?.typeA === 'number') {
        console.log('result', result);
        // console.log('tax_rate', tax_rate);
        if (item.tax_type === '1') {
          item.tax = parseFloat(
            ((parseFloat(result) * tax_rate.typeB) / item.quantity / 100).toFixed(2)
          );
        } else if (item.tax_type === '2') {
          item.tax = parseFloat(
            ((parseFloat(result) * tax_rate.typeC) / item.quantity / 100).toFixed(2)
          );
        } else if (item.tax_type === '3') {
          item.tax = parseFloat(
            ((parseFloat(result) * tax_rate.typeD) / item.quantity / 100).toFixed(2)
          );
          // typeA is the default tax rate
        } else {
          item.tax = parseFloat(
            ((parseFloat(result) * tax_rate.typeA) / item.quantity / 100).toFixed(2)
          );
        }
      } else {
        // console.log('tax');
        item.tax = parseFloat(((parseFloat(result) * tax) / item.quantity / 100).toFixed(2));
      }
      return totalCost + result;
    }, 0);
    return total;
  };

  const getPrice = (cart) => {
    const total = cart.reduce((totalCost, item) => {
      return (totalCost += parseFloat((item.price * item.quantity).toFixed(2)));
    }, 0);
    return total;
  };

  function getPirceString(cart) {
    const total = getPrice(cart);
    return total.toLocaleString(mainL, currencyOptions);
  }

  function getSubTotal(cart) {
    const total = calculateSub(cart);
    return total.toLocaleString(mainL, currencyOptions);
  }

  function getDiscountTotal(cart) {
    const total = calculateDiscount(cart);
    return total.toLocaleString(mainL, currencyOptions);
  }

  function getTotal(cart) {
    let subtotal = calculateSub(cart);
    subtotal = parseFloat(subtotal.toFixed(2));

    finalTax = cart.reduce((totalCost, item) => {
      return totalCost + item.tax * item.quantity;
    }, 0);

    let total = subtotal + finalTax;
    total = parseFloat(total.toFixed(2));
    totalPrice = total;
    return total.toLocaleString(mainL, currencyOptions);
  }

  function getFinalTax(cart) {
    const tax = cart.reduce((totalCost, item) => {
      return totalCost + item.tax * item.quantity;
    }, 0);
    return tax.toLocaleString(mainL, currencyOptions);
  }

  useEffect(() => {
    let symbol = JSON.parse(localStorage.getItem('machine'))?.currency?.symbol;
    symbol = symbol ? symbol : '$';

    const prods = cart.map((prod, i) => {
      // console.log(prod);
      // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.image}/${prod.referTo}`;
      const url = isLocal
        ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.image}`
        : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.image}/${prod.referTo}`;

      prod.name = prod.title;
      return (
        <ProductCard
          remove={remove}
          langs={langs}
          mainL={mainL}
          symbol={symbol}
          cart={props.cart}
          alterquantity={props.alterquantity}
          add={props.add}
          decreStock={decreStock}
          prod={prod}
          image={url}
          key={i}
        />
      );
    });
    console.log(cart);
    setProducts(prods);
  }, [cart]);

  if (showCart) {
    return (
      <ClickOutSideDiv setShowCart={setShowCart}>
        <div className="shopping-cart">
          <div className="shopping-cart-left">
            <div className="cart-title-div">
              <div className="cart-title-bottom"> {t(`Your Cart`)}</div>
            </div>

            <div className="cart-home-products">{products}</div>
          </div>
          {cart && cart.length > 0 && (
            <div className="shopping-cart-right">
              <div style={{ textAlign: 'right' }}>
                <div
                  className={check ? 'view-more-button' : 'view-more-button-reverColor'}
                  onClick={checkout}
                >
                  {t(`CHECKOUT`)}
                </div>
                {hasTerm && (
                  <div className="mt-3 buttonColor d-flex justify-content-end">
                    <input
                      type="checkbox"
                      checked={check}
                      onChange={handleCheck}
                      className="checkboxColor mr-3"
                    />
                    <span onClick={term}>{t(`I agree to the Terms and Conditions`)}</span>
                  </div>
                )}
              </div>

              {/* <div className="promo-code cart-total-text">Promo Code </div> */}
              {/* <div className="cart-total-text cart-subtotal" style={{ marginTop: '188px' }}> */}
              <div
                className="cart-total-text cart-subtotal"
                style={hasTerm ? { marginTop: '180px' } : { marginTop: '210px' }}
              >
                <p>
                  <span className="cart-left-text">{t(`Sub total`)}: </span>
                  <span className="cart-right-text">
                    {mainL != 'fr-CA' && symbol}
                    {getPirceString(props.cart)}
                    {mainL == 'fr-CA' && symbol}
                  </span>
                </p>
              </div>
              <div className="cart-total-text">
                <p>
                  <span className="cart-left-text">{t(`Discount`)}: </span>
                  <span className="cart-right-text">
                    {mainL != 'fr-CA' && symbol}
                    {getDiscountTotal(props.cart)}
                    {mainL == 'fr-CA' && symbol}
                  </span>
                </p>
              </div>
              <div className="cart-total-text">
                <p>
                  <span className="cart-left-text">{t('Tax')}: </span>
                  <span className="cart-right-text">
                    {mainL != 'fr-CA' && symbol}
                    {getFinalTax(props.cart)}
                    {mainL == 'fr-CA' && symbol}
                  </span>
                </p>
              </div>
              <div className="cart-totalfinal-text">
                <p>
                  <span className="cart-left-text">{t(`Total`)}:</span>
                  <span className="cart-right-text">
                    {mainL != 'fr-CA' && symbol}
                    {getTotal(props.cart)}
                    {mainL == 'fr-CA' && symbol}
                  </span>
                </p>
              </div>
            </div>
          )}
        </div>
        <FAQ show={showTerm} setShow={setShowTerm} langs={langs} />
      </ClickOutSideDiv>
    );
  } else {
    return null;
  }
}
export default BottomCard;
